<div class="pharmacy-details-container">
  @if (dataSource) {
    <div class="medication-details-table">
      <div class="row mb-4">
        <div class="col-md-4">
          <label class="filter-label">Filter By</label>
          <input class="form-control searchInput" matInput placeholder="Search Records" (keyup)="applyFilter($event)"
            #input>
          </div>
          <div class="col-md-4"></div>
          <div class="col-md-4 filterMode-section ">
            <label class="filter-label">Filter By Claim</label>
            <select [(ngModel)]="filterMode" (change)="onChange($event)" class="form-control filterMode">
              @for (item of items; track item) {
                <option [value]="item"> {{ item }} </option>
              }
            </select>
            <div class="caret">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                <path
                  d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                </svg>
              </div>
            </div>
          </div>
          <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
            <ng-container matColumnDef="dateOfService">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Service Date</th>
              <td mat-cell *matCellDef="let med">{{ med.dateOfService | date:'MM/dd/yyyy' }}</td>
            </ng-container>
            <ng-container matColumnDef="drugDescription">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Drug Description</th>
              <td mat-cell *matCellDef="let med">{{ med.drugDescription }}</td>
            </ng-container>
            <ng-container matColumnDef="strengthName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Strength</th>
              <td mat-cell *matCellDef="let med">{{ med.strengthName }}</td>
            </ng-container>
            <ng-container matColumnDef="drugType">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
              <td mat-cell *matCellDef="let med">{{ med.drugType }}</td>
            </ng-container>
            <ng-container matColumnDef="daysSupply">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Days Supply</th>
              <td mat-cell *matCellDef="let med">{{ med.daysSupply }}</td>
            </ng-container>
            <ng-container matColumnDef="metricQuantity">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Metric Quantity</th>
              <td mat-cell *matCellDef="let med">{{ med.metricQuantity }}</td>
            </ng-container>
            <ng-container matColumnDef="rxInstruction">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Rx Instructions</th>
              <td mat-cell *matCellDef="let med">{{ med.rxInstruction }}</td>
            </ng-container>
            <ng-container matColumnDef="pharmacyName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Pharmacy</th>
              <td mat-cell *matCellDef="let med">{{ med.pharmacyName }}</td>
            </ng-container>
            <ng-container matColumnDef="prescriberFullName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Prescriber</th>
              <td mat-cell *matCellDef="let med">{{ med.prescriberFullName }}</td>
            </ng-container>
            <ng-container matColumnDef="tier">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Tier</th>
              <td mat-cell *matCellDef="let med">{{ med.tier }}</td>
            </ng-container>
            <ng-container matColumnDef="claimStatusDescription">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Claim Status</th>
              <td mat-cell *matCellDef="let med">{{ med.claimStatusDescription }}</td>
            </ng-container>
            <ng-container matColumnDef="adjudicationDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Adjudication Date</th>
              <td mat-cell *matCellDef="let med">{{ med.adjudicationDate | date:'MM/dd/yyyy' }}</td>
            </ng-container>
            <ng-container *matNoDataRow>
              <tr>
                <td class="noRecordAvailable" [attr.colspan]="displayedColumns.length"> No records available </td>
              </tr>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <mat-paginator [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
          </mat-paginator>
        </div>
      }
    </div>